import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import AutocompleteSelect from 'chameleon/ui-stack/ui/forms/autocomplete-select';
import './styles.scss';

const StudentsDropdown = (props) => {
  const { students, studentId, onChange } = props;
  const options = students.map(
    ({ user_id: userId, first_name: firstName, last_name: lastName }) => ({
      label: `${firstName} ${lastName}`,
      value: userId.toString(),
    }),
  );

  const selectedStudent =
    options.find(({ value }) => value === studentId) || {};
  return (
    <AutocompleteSelect
      data-test-students-dropdown
      className="DropdownFilter-root StudentsDropdown"
      options={options}
      value={selectedStudent}
      onChange={onChange}
      placeholder={{
        label: 'Select a Student',
      }}
    />
  );
};

StudentsDropdown.propTypes = {
  students: PropTypes.array.isRequired,
  studentId: PropTypes.string.isRequired,
};

StudentsDropdown.defaultProps = {
  students: [],
};

export default withRouter(StudentsDropdown);
